<!-- 侧弹窗-设置安全模式 -->
<template>
	<div>
		<right-panel :datas="connects" ref="rightPanelSet" @onClose="onClose">
			<div slot="header">
				<translate>Set The Security Mode</translate>
			</div>
			<div slot="content" class="wrapper-padding">
				<div class="safe-mode">
					<el-form ref="form" :model="safeMode" label-width="110px">
						<!-- 设置状态 -->
						<el-form-item :label="attrText.setstatus">
							<el-radio class="radio" v-model="safeMode.setRadio" label="1">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="safeMode.setRadio" label="0">
								<translate>off</translate>
							</el-radio>
							<p class="set-text">
								<translate> Security mode can only block Linux command operations, not including scripts and other ways. </translate>
							</p>
						</el-form-item>
						<!-- 拦截指令 -->
						<el-form-item :label="attrText.blockCommand">
							<el-col :span="20">
								<el-input v-model.trim="safeMode.command" :disabled="safeMode.setRadio === '0'" placeholder=""></el-input>
							</el-col>
							<el-col :span="4">
								<el-button type="text" :disabled="safeMode.setRadio === '0'" @click="addCommand()">
									<translate>Add</translate>
								</el-button>
							</el-col>
							<translate tag="p">Please enter a command to block, including multiple commands separated by "," </translate>
							<el-table :data="safeMode.blockCommand" stripe :empty-text="attrText.notCommand" style="width: 100%; margin-top: 20px">
								<el-table-column prop="command" :label="attrText.Command"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeCommand(scope.row.command)" :disabled="safeMode.setRadio === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
						<!-- 安全模式审批 -->
						<el-form-item :label="attrText.safemode">
							<el-radio class="radio" v-model="safeMode.safeRadio" label="1" :disabled="safeMode.setRadio === '0'">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="safeMode.safeRadio" label="0" :disabled="safeMode.setRadio === '0'">
								<translate>off</translate>
							</el-radio>
						</el-form-item>
						<!-- 审批人 -->
						<el-form-item :label="attrText.approver">
							<el-col :span="20">
								<el-select v-model="safeMode.name" :placeholder="attrText.selected" :disabled="safeMode.safeRadio === '0'">
									<el-option v-for="(item, index) in safeMode.nameList" :label="`${item.name}(${item.account})`" :value="item.name" :key="index"></el-option>
								</el-select>
							</el-col>
							<el-col :span="4">
								<el-button type="text" :disabled="safeMode.safeRadio === '0'" @click="addApprover()">
									<translate>Add</translate>
								</el-button>
							</el-col>
							<el-table :data="safeMode.approver" stripe :empty-text="attrText.noApprover" style="width: 100%; margin-top: 50px">
								<el-table-column prop="name" :label="attrText.approver"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeApprover(scope.row.name)" :disabled="safeMode.safeRadio === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>

						<!-- 系统指令告警 -->
						<el-form-item :label="attrText.systemCommandAlarm">
							<el-radio class="radio" v-model="alarmMode.alarmRadio" label="1">
								<translate>on</translate>
							</el-radio>
							<el-radio class="radio" v-model="alarmMode.alarmRadio" label="0">
								<translate>off</translate>
							</el-radio>
							<!-- <p class="set-text">
								<translate> Security mode can only block Linux command operations, not including scripts and other ways. </translate>
							</p> -->
						</el-form-item>
						<!-- 告警指令 -->
						<el-form-item :label="attrText.alarmInstruction">
							<el-col :span="20">
								<el-input v-model.trim="alarmMode.command" :disabled="alarmMode.alarmRadio === '0'" placeholder=""></el-input>
							</el-col>
							<el-col :span="4">
								<el-button type="text" :disabled="alarmMode.alarmRadio === '0'" @click="addAlarmCommand()">
									<translate>Add</translate>
								</el-button>
							</el-col>
							<translate tag="p">Please enter a command to alarm, including multiple commands separated by "," </translate>
							<el-table :data="alarmMode.blockCommand" stripe :empty-text="attrText.notAlarmCommand" style="width: 100%; margin-top: 20px">
								<el-table-column prop="command" :label="attrText.Command"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeAlarmCommand(scope.row.command)" :disabled="alarmMode.alarmRadio === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
						<!-- 通知人 -->
						<el-form-item :label="attrText.notifier">
							<el-col :span="20">
								<el-select v-model="alarmMode.name" :placeholder="attrText.selected" :disabled="alarmMode.alarmRadio === '0'">
									<el-option v-for="(item, index) in alarmMode.nameList" :label="`${item.name}(${item.account})`" :value="item.name" :key="index"></el-option>
								</el-select>
							</el-col>
							<el-col :span="4">
								<el-button type="text" :disabled="alarmMode.alarmRadio === '0'" @click="addNotifier()">
									<translate>Add</translate>
								</el-button>
							</el-col>
							<el-table :data="alarmMode.notifier" stripe :empty-text="attrText.noNotifier" style="width: 100%; margin-top: 50px">
								<el-table-column prop="name" :label="attrText.notifier"></el-table-column>
								<el-table-column :label="attrText.action" width="100">
									<template scope="scope">
										<el-button type="text" @click="removeNotifier(scope.row.name)" :disabled="alarmMode.alarmRadio === '0'">
											<translate>Remove</translate>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div slot="footer" class="detail-btn">
				<el-button type="primary" :disabled="safeMode.safeRadio === '1' && safeMode.approver.length === 0" @click="onSubmitSafeMode()" :loading="loading">
					<translate>Save</translate>
				</el-button>
				<el-button @click="$refs.rightPanelSet.onClose()">
					<translate>Cancel</translate>
				</el-button>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import ElForm from '../../../../node_modules/element-ui/packages/form/src/form'
import ElButton from '../../../../node_modules/element-ui/packages/button/src/button'
import { Utils } from '../../../config'
export default {
	name: 'ClusterSafeMode',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			loading: false,
			safeMode: {
				setRadio: '1',
				safeRadio: '1',
				command: '',
				name: '',
				nameList: [],
				blockCommand: [],
				addCommand: [],
				delCommand: [],
				approver: [],
			},
			alarmMode: {
				alarmRadio: '1',
				command: '',
				name: '',
				nameList: [],
				blockCommand: [],
				addCommand: [],
				delCommand: [],
				notifier: [],
			},

			detailInfo: this.$store.getters.cluster.detail.info,
		}
	},
	computed: {
		attrText() {
			return this.initTranslateText()
		},
	},
	created() {
		this.getSafeApprover()
		setTimeout(() => {
			this.safeMode = Object.assign({}, this.safeMode, {
				setRadio: this.items.safe_mode ? '1' : '0',
				safeRadio: this.items.safe_mode_approver ? '1' : '0',
				blockCommand: [].concat(this.items.need_intercept_commands || []),
				approver: [].concat(this.items.approver_accounts || []),
			})

			this.alarmMode = Object.assign({}, this.alarmMode, {
				alarmRadio: this.items.safe_mode_notice ? '1' : '0',
				blockCommand: [].concat(this.items.need_notice_commands || []),
				notifier: [].concat(this.items.notice_accounts || []),
			})
		}, 300)
	},
	methods: {
		// 提取翻译文本
		initTranslateText() {
			return {
				selected: this.$gettext('Please select'),
				approver: this.$gettext('Approver'),
				notifier: this.$gettext('Notifier'),
				action: this.$gettext('Action'),
				setstatus: this.$gettext('Set Status'),
				systemCommandAlarm: this.$gettext('System command alarm'),
				alarmInstruction: this.$gettext('Alarm instruction'),
				blockCommand: this.$gettext('Block Command'),
				Command: this.$gettext('Command'),
				safemode: this.$gettext('Security Mode Application'),
				noApprover: this.$gettext('Not set approver'),
				noNotifier: this.$gettext('Not set notifier'),
				notCommand: this.$gettext('Not set up block command'),
				notAlarmCommand: this.$gettext('Not set up alarm command'),
			}
		},
		// 添加指令
		addCommand() {
			if (this.safeMode.command !== '') {
				let stringArr = this.safeMode.command.split(',')
				let that = this
				let cammandArr = this.safeMode.blockCommand.map((item) => item.command)
				stringArr.forEach(function (item) {
					if (cammandArr.indexOf(item) < 0) {
						that.safeMode.blockCommand.push({ command: item, network_id: that.detailInfo.id })
						that.safeMode.addCommand.push({ command: item, network_id: that.detailInfo.id })
					}
				})
			}
			this.safeMode.command = ''
		},
		// 移除指令
		removeCommand(val) {
			this.safeMode.blockCommand.forEach((item) => {
				if (item.command === val) {
					let key = this.safeMode.blockCommand.indexOf(item)
					this.safeMode.blockCommand.splice(key, 1)
					this.safeMode.delCommand.push(item)
				}
			})
		},
		// 添加告警指令
		addAlarmCommand() {
			if (this.alarmMode.command !== '') {
				let stringArr = this.alarmMode.command.split(',')
				let that = this
				let cammandArr = this.alarmMode.blockCommand.map((item) => item.command)
				stringArr.forEach(function (item) {
					if (cammandArr.indexOf(item) < 0) {
						that.alarmMode.blockCommand.push({ command: item, network_id: that.detailInfo.id })
						that.alarmMode.addCommand.push({ command: item, network_id: that.detailInfo.id })
					}
				})
			}
			this.alarmMode.command = ''
		},
		// 移除告警指令
		removeAlarmCommand(val) {
			this.alarmMode.blockCommand.forEach((item) => {
				if (item.command === val) {
					let key = this.alarmMode.blockCommand.indexOf(item)
					this.alarmMode.blockCommand.splice(key, 1)
					this.alarmMode.delCommand.push(item)
				}
			})
		},
		// 获取安全模式审核人列表
		getSafeApprover() {
			let params = {
				results_per_page: Utils.config.maxPageSize,
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.GET_SAFE_APPROVER, params).then((res) => {
				this.safeMode.nameList = res.objects
				this.alarmMode.nameList = res.objects
			})
		},
		// 添加审核人
		addApprover() {
			console.log('this.safeMode.name ', this.safeMode, this.safeMode.name)
			if (this.safeMode.name !== '') {
				var have = false
				console.log(this.safeMode.approver, this.safeMode.name)
				this.safeMode.approver.forEach((item) => {
					if (item.name === this.safeMode.name) {
						have = true
					}
				})
				if (!have) {
					this.safeMode.nameList.forEach((item) => {
						if (item.name === this.safeMode.name) {
							this.safeMode.approver.push(item)
						}
					})
				}
				console.log(have)
			}
		},
		// 删除审核人
		removeApprover(val) {
			this.safeMode.approver.forEach((item) => {
				if (item.name === val) {
					let key = this.safeMode.approver.indexOf(item)
					this.safeMode.approver.splice(key, 1)
					this.$notify({
						type: 'success',
						message: this.$gettext('Remove successfully!'),
					})
				}
			})
		},
		// 添加通知人
		addNotifier() {
			console.log('this.alarmMode.name ', this.alarmMode, this.alarmMode.name)
			if (this.alarmMode.name !== '') {
				var have = false
				console.log(this.alarmMode.notifier, this.alarmMode.name)
				this.alarmMode.notifier.forEach((item) => {
					if (item.name === this.alarmMode.name) {
						have = true
					}
				})
				if (!have) {
					this.alarmMode.nameList.forEach((item) => {
						if (item.name === this.alarmMode.name) {
							this.alarmMode.notifier.push(item)
						}
					})
				}
				console.log(have)
			}
		},
		// 删除通知人
		removeNotifier(val) {
			this.alarmMode.notifier.forEach((item) => {
				if (item.name === val) {
					let key = this.alarmMode.notifier.indexOf(item)
					this.alarmMode.notifier.splice(key, 1)
					this.$notify({
						type: 'success',
						message: this.$gettext('Remove successfully!'),
					})
				}
			})
		},

		// 提交安全模式设置
		onSubmitSafeMode() {
			console.log(this.safeMode, 'safeMode')
			console.log(this.alarmMode, 'alarmMode')
			this.loading = true
			// 删除指令
			if (this.safeMode.delCommand.length !== 0 || this.alarmMode.delCommand.length !== 0) {
				if (this.safeMode.delCommand.length !== 0) {
					let safeIds = this.safeMode.delCommand.map((item) => item.id).join(',')
					this.$store.dispatch(STORE_CONST.CLUSTER.DEL_INTERCEPT, safeIds).then((res) => {
						// 添加指令
						if (this.safeMode.addCommand.length !== 0) {
							this.$store.dispatch(STORE_CONST.CLUSTER.ADD_INTERCEPT, { data: { intercept: this.safeMode.addCommand } }).then((res) => {})
						}
					})
				}
				if (this.alarmMode.delCommand.length !== 0) {
					let alarmIds = this.alarmMode.delCommand.map((item) => item.id).join(',')
					this.$store.dispatch(STORE_CONST.CLUSTER.DEL_ALARM_INTERCEPT, alarmIds).then((res) => {
						// 添加指令
						if (this.safeMode.addCommand.length !== 0) {
							this.$store.dispatch(STORE_CONST.CLUSTER.ADD_INTERCEPT, { data: { notice: this.alarmMode.addCommand } }).then((res) => {})
						}
					})
				}
			} else {
				// 添加指令
				if (this.safeMode.addCommand.length !== 0 || this.alarmMode.addCommand.length !== 0) {
					this.$store.dispatch(STORE_CONST.CLUSTER.ADD_INTERCEPT, { data: { intercept: this.safeMode.addCommand, notice: this.alarmMode.addCommand } }).then((res) => {})
				}
			}
			let account = this.safeMode.approver.map((item) => item.id).join(',')
			let notifier = this.alarmMode.notifier.map((item) => item.id).join(',')
			let params = {
				id: this.$route.params.id,
				data: {
					approver_accounts: account,
					notice_accounts: notifier,
					safe_mode: Number(this.safeMode.setRadio),
					safe_mode_approver: Number(this.safeMode.safeRadio),
					safe_mode_notice: Number(this.alarmMode.alarmRadio),
				},
			}
			this.$store.dispatch(STORE_CONST.CLUSTER.CHANGE, params).then(
				(res) => {
					this.loading = false
					this.$store.commit(STORE_CONST.CLUSTER.UPDATE_DETAIL, res)
				},
				() => {
					this.loading = false
				}
			)
			this.$refs.rightPanelSet.onClose()
		},
		onClose() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
				console.log('watch--->items', this.items)
			},
			deep: true,
		},
	},
	components: {
		ElButton,
		ElForm,
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.safe-mode {
	.el-table__empty-text {
		position: relative;
		left: 0;
		top: 0;
		line-height: 60px;
	}
	.set-text {
		line-height: 20px;
	}
	.el-button--text {
		margin-left: 10px;
	}
	.el-radio + .el-radio {
		margin-top: 0;
	}
}
</style>



// WEBPACK FOOTER //
// cluster-safe-mode.vue?b953e68c